import WorkspaceRouteComponent from "@/components/shared/WorkspaceRouteComponent";
import {Component} from "vue-facing-decorator";

/** O par do WorkflowLevelRouteComponent: telas dirigidas pelo `:domain` da URL. */
@Component
class DomainLevelRouteComponent extends WorkspaceRouteComponent {

    get domain() {
        return this.workspace.domainWith(this.params.domain)!
    }

    /**
     * Pelo objeto GUARDADO no workspace, e não pelo `domain` acima: aquele é uma cópia
     * enriquecida, e atualizar a cópia não mudaria o que o resto do app lê.
     */
    private get storedDomain() {
        return this.workspace.domains.find(domain => domain.alias === this.params.domain)!
    }

    async updateCurrentDomain(changes: any) {
        return this.updateDomain(this.storedDomain, changes)
    }

    async deleteCurrentDomain() {
        return this.deleteDomain(this.storedDomain)
    }
}

export default DomainLevelRouteComponent
